import { NotificationRuleNotificationType } from '@eppendorf/vnls-notifications-utils';

export const initialPageIndex = 1;
export const initialPageSize = 500;

const DEFAULT_ESCALATION_OPTIONS = [
  { value: '15', label: '15 min' },
  { value: '30', label: '30 min' },
  { value: '45', label: '45 min' },
  { value: '60', label: '1 hour' },
  { value: '120', label: '2 hours' },
  { value: '240', label: '4 hours' },
];

const EXTENDED_ESCALATION_OPTIONS = [
  { value: '480', label: '8 hours' },
  { value: '720', label: '12 hours' },
  { value: '960', label: '16 hours' },
];

export const escalateAfterOptions = [
  [...DEFAULT_ESCALATION_OPTIONS],
  [...DEFAULT_ESCALATION_OPTIONS],
  [...DEFAULT_ESCALATION_OPTIONS, ...EXTENDED_ESCALATION_OPTIONS],
];

export const defaultEscalateAfterValue = 30;

export const notificationCadenceOptions = [
  { value: '5', label: '5 min' },
  { value: '10', label: '10 min' },
  { value: '15', label: '15 min' },
  { value: '30', label: '30 min' },
];

export const defaultNotificationCadence = 15;

export const notificationDelayOptions = [
  { value: '0', label: 'none' },
  { value: '60', label: '1 min' },
  { value: '120', label: '2 min' },
  { value: '300', label: '5 min' },
  { value: '600', label: '10 min' },
  { value: '900', label: '15 min' },
  { value: '1200', label: '20 min' },
  { value: '1800', label: '30 min' },
];

export const defaultNotificationDelay = 300;

export const allNotificationTypes: Exclude<
  NotificationRuleNotificationType,
  'Escalated'
>[] = ['Created', 'Acknowledged', 'AutoResolved', 'Expired', 'Archived'];
